// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_xsr","top":"styles_top__fkupS"};